// https://javascript.info/import-export
import { init_menu } from './parts/mobileMenu.js';
import { menu_dropdowns } from './parts/menuDropdowns.js';
import SearchForm from './parts/searchForm.js';
import { Fancybox } from "@fancyapps/ui";
import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

jQuery( $ => {

	// mmenu light
	init_menu();

	// Menu Dropdowns
	menu_dropdowns();

	// search form functions
	new SearchForm();

	function homepage_sticky_header() {

		let header = document.querySelector(".home .header");

		if (header === null) return;

		window.addEventListener("scroll", function () {

			if (window.scrollY > 400 ) {
				header.classList.add("is-sticky");
			} else {
				header.classList.remove("is-sticky");
			}

		});
	}
	homepage_sticky_header();


	// Fancybox (videos popup)
	Fancybox.bind('[data-fancybox="gallery"]', {
		youtube: { controls: 1, showinfo: 0 }
	});


	// Annoucement Slider
	// https://splidejs.com/extensions/auto-scroll/
	let annoucements = document.querySelector( '.announcements .splide' );

	if(annoucements){
		new Splide( annoucements, {
			type		: 'loop',
			perPage		: 1,
			pagination	: false,
			arrows		: false,
			gap			: '50vw',
			autoWidth	: true,
			focus		: 'center',
			autoScroll: {
				speed: 0.5,
			}
		} ).mount( { AutoScroll } );
	}

	$( document.body ).on( 'updated_checkout', function( event ) {
		
		let shipping_methods = document.querySelectorAll('input.shipping_method');

		if( shipping_methods ){
			
			let selected = Array.from( shipping_methods ).filter( method => method.checked == true );

			if( selected ){
				$('.billing-dynamic_pickup').toggleClass('hide_pickup', selected[0].value == 'local_pickup:2');
				$('.billing-dynamic_pickup').toggleClass('validate-required',  selected[0].value == 'local_pickup:2');
			}

		}

	});
})